import { render } from "./Photo4.vue?vue&type=template&id=a407f7c8"
import script from "./Photo4.vue?vue&type=script&lang=js"
export * from "./Photo4.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__